export default __webpack_public_path__ + "static/media/task.dc9fe464.svg";